import api from './api';

import type { CurrentUser } from '@/types/user';

export const userService = {
  getCurrentUser: async (): Promise<CurrentUser> => {
    const response = await api.get<CurrentUser>('/resources/current');
    return response.data;
  },
};
